export default __webpack_public_path__ + "static/topmenu05@2x-67edb94bec410668d60113613ebb4dca.png";